import round from 'lodash-es/round';

import { DECIMAL_PRECISION } from '../../../constants';
import { t } from '../../../locale';
import { ValidationMessage, ValidationRule } from '../useValidation.types';
import isDefined from '../utils/isDefined';

interface Config {
  message?: ValidationMessage;
}

export default function price(config: Config = {}): ValidationRule {
  return {
    name: 'price',
    validator(value) {
      const price = Number(value);

      return (
        !isDefined(value) || (price !== Infinity && price >= 0 && price === round(price, DECIMAL_PRECISION.CURRENCY))
      );
    },
    message: config.message || t('ll.validation.price'),
  };
}
